export default __webpack_public_path__ + "static/media/roughnessActive.7d158052.svg";